import { snakeToText } from "@utils/helperFunctions";
import { Button } from "react-bootstrap";
import { normalizeCasing } from "../common";

const About = ({ app, onClickBack }) => {
  const appName = snakeToText(app.service);
  return (
    <div data-testid="aboutConnectionPage" className="aboutConnectionPage">
      <div className="connectionsHeader">
        <div className="info">
          <div className="logoBox spaceRight">
            <img className="smallLogoImg" src={app.logo} />
          </div>
          <div>
            <h3 className="text24 appName">{appName}</h3>
            <div className="summary headerSummary">{app.summary}</div>
            <a href={app.helpUrl} target="_blank" className="setupLink">
              How do I set up {appName}?
            </a>
          </div>
        </div>
        <div className="flexCenter">
          <Button onClick={onClickBack} className="ssButtonBgWhite spaceRight">
            Back
          </Button>
          <Button onClick={onClickBack} className="squareGreenButton">
            Activate Integration
          </Button>
        </div>
      </div>
      <hr></hr>
      <h3 className="text24">About {appName}</h3>
      <p className="instructionalText">{app.description}</p>
      <h3 className="text24">Features</h3>
      <ul className="featureList">
        {app &&
          app.features &&
          app.features.map((feature) => (
            <li className="instructionalText" key={feature}>
              {feature}
            </li>
          ))}
      </ul>
      <h3 className="text24">Integration Supports</h3>
      <p className="instructionalText">
        {app &&
          app.categories &&
          app.categories.map((cat, index) => {
            if (index === app.categories.length - 1) {
              return <span key={index}>{normalizeCasing(cat.category)}</span>;
            } else if (index === app.categories.length - 2) {
              return (
                <span key={index}>
                  {normalizeCasing(cat.category)}
                  {app.categories.length > 2 ? "," : null}&nbsp;and&nbsp;
                </span>
              );
            } else {
              return (
                <span key={index}>{normalizeCasing(cat.category)},&nbsp;</span>
              );
            }
          })}
      </p>
    </div>
  );
};

export default About;
